// extracted by mini-css-extract-plugin
module.exports = {"dots":"styles_dots__1q7Io"};